import { createReducer, on } from '@ngrx/store';
import { PartnerListInterface } from '../types/partner-list';
import { defaultPartnerListFilter } from '../types/partner-list-filter';
import {
  fetchPartnerList,
  loadedPartnerList,
  failedPartnerList,
  updatePartnerListFilter,
  deletePartner,
  resetPartnerList,
} from './partner-list.actions';
import {
  initialPartnerListState,
  PartnerListState,
  initialDataSource,
} from './partner-list.state';

export const partnerListReducer = createReducer(
  initialPartnerListState,
  on(fetchPartnerList, (state): PartnerListState => ({ ...state })),
  on(loadedPartnerList, (state, action): PartnerListState => {
    return {
      ...state,
      filter: { ...state.filter },
      dataSource: action.dataSource,
    };
  }),
  on(failedPartnerList, (state): PartnerListState => {
    return {
      ...state,
      filter: { ...state.filter },
      dataSource: { ...initialDataSource },
    };
  }),
  on(updatePartnerListFilter, (state, { filter }): PartnerListState => {
    return {
      ...state,
      filter: { ...state.filter, ...(filter ?? defaultPartnerListFilter) },
      dataSource: { ...state.dataSource },
    };
  }),
  on(deletePartner, (state, action): PartnerListState => {
    return {
      ...state,
      filter: { ...state.filter },
      dataSource: {
        ...state.dataSource,
        rawData: state.dataSource.rawData?.filter(
          (partner: PartnerListInterface) =>
            partner.partner_id !== action.partner_id
        ),
      },
    };
  }),
  on(resetPartnerList, (state): PartnerListState => {
    return {
      ...state,
      filter: { ...defaultPartnerListFilter },
      dataSource: { ...state.dataSource },
    };
  })
);
